<template>
  <div class="h-100 d-flex flex-column">
    <!-- https://www.primefaces.org/primevue/showcase-v2/#/datatable -->
    <div class="row f-row h-100 justify-content-center">
      <div
        class="col col-12 text-center justify-content-center"
        style="width:100%; padding: 0 5px 0 5px;
        height: calc(100vh - 128px)!important;"
      >
        <DataTable
          :alwaysShowPaginator="true"
          :filters.sync="filters"
          :loading="showLoading"
          :paginator="true"
          :rowHover="true"
          :rows="15"
          :rowsPerPageOptions="[10, 15, 20, 25, 30, 50, 100, 1000]"
          :scrollable="true"
          :selection.sync="selectedExposures"
          :value="dataVar"
          :virtual="true"
          ref="dt"
          class="p-datatable-sm editable-cells-table"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
          editMode="cell"
          :filterDisplay="showFilters ? 'menu' : ''"
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          responsiveLayout="scroll"
          stickyHeader="true"
        >
          <!-- @cell-edit-complete="onCellEditComplete"-->
          <template #header>
            <div
              class="flex justify-content-between align-items-center"
              style="background: var(--lightbackground3)!important;"
            >
              <table
                class="table table-sm table-borderless"
                style="padding: 0 5px 0 5px;"
              >
                <tbody>
                  <tr>
                    <td style="width: 10%" class="txt-label-primary">
                      <span class="p-input-icon-left">
                        <i
                          class="pi pi-search"
                          style="font-size: 0.75rem!important;"
                        />
                        <InputText
                          style="font-size: 0.75rem!important;"
                          v-model="filters['global'].value"
                          placeholder="Keyword Search"
                        />
                      </span>
                    </td>
                    <td
                      class="txt-label-primary text-center"
                      style="width: 10%; padding-top: 5px!important;"
                    >
                      <ToggleButton
                        :id="'fields'"
                        :defaultState="false"
                        :labelEnableText="'- Fields'"
                        :labelDisableText="'+ Fields'"
                        v-on:change="showAllFields = !showAllFields"
                      />
                    </td>
                    <td
                      class="txt-label-primary text-center"
                      style="width: 10%"
                    >
                      Download:
                      <button
                        v-on:click="download"
                        type="submit"
                        class="btn-up-dn-load txt-label-primary"
                      >
                        <i class="fa fa-download" aria-hidden="true"></i>
                      </button>
                    </td>
                    <td
                      class="txt-label-primary text-center"
                      style="width: 10%"
                    >
                      Add:
                      <button
                        v-on:click="onClientCreate"
                        type="submit"
                        class="btn-up-dn-load txt-label-primary"
                      >
                        <i class="fa fa-plus" aria-hidden="true"></i>
                      </button>
                    </td>
                    <td
                      class="txt-label-primary text-center"
                      style="width: 10%"
                    >
                      {{ saveLegend }}
                      <button
                        v-on:click="onClientSaveToDB"
                        v-if="!dataSaved"
                        type="submit"
                        class="btn-up-dn-load txt-label-primary btn-warn"
                      >
                        <i class="fa fa-save" aria-hidden="true"></i>
                      </button>
                      <i class="fa fa-check" aria-hidden="true" v-else></i>
                    </td>
                    <td
                      class="txt-label-primary text-center"
                      style="width: 10%"
                    >
                      {{ refreshLegend }}
                      <button
                        v-on:click="onClientDiscard"
                        v-if="!dataSaved"
                        type="submit"
                        class="btn-up-dn-load txt-label-primary btn-warn"
                      >
                        <i class="fa fa-refresh" aria-hidden="true"></i>
                      </button>
                      <i class="fa fa-check" aria-hidden="true" v-else></i>
                    </td>
                    <td
                      class="txt-label-primary text-center"
                      style="width: 10%"
                    >
                      Delete:
                      <button
                        v-on:click="deleteFromDB"
                        type="submit"
                        class="btn-up-dn-load txt-label-primary"
                      >
                        <i class="fa fa-trash" aria-hidden="true"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </template>
          <template #empty>
            No exposures found.
          </template>
          <template #loading>
            Loading exposures. Please wait.
          </template>

          <Column
            field="actions"
            header="Actions"
            sortable
            :styles="{ 'min-width': '5rem' }"
          >
            <template #body="{data}">
              <i
                class="fa fa-exclamation program"
                aria-hidden="true"
                v-show="data.edited"
              ></i>
              <button
                v-on:click="onEditItem(data)"
                type="submit"
                class="btn-edit-delete"
              >
                <i class="fa fa-pencil" aria-hidden="true"></i>
              </button>
              <button
                v-on:click="onCopyItem(data)"
                type="submit"
                class="btn-edit-delete"
              >
                <i class="fa fa-copy" aria-hidden="true"></i>
              </button>
              <button
                v-on:click="onDeleteItem(data)"
                type="submit"
                class="btn-edit-delete"
              >
                <i class="fa fa-trash" aria-hidden="true"></i>
              </button>
            </template>
          </Column>

          <Column
            field="custom_id"
            header="ID"
            sortable
            :styles="{ 'min-width': '5rem' }"
          >
            <template #body="{data}">
              {{ data.custom_id }}
            </template>
            <template #filter="{filterModel}">
              <InputText
                type="text"
                v-model="filterModel.value"
                class="p-column-filter"
                placeholder="Search by id"
              />
            </template>
          </Column>

          <Column
            field="custom_name"
            header="Contract"
            sortable
            :styles="{ 'min-width': '8rem' }"
          >
            <template #body="{data}">
              {{ data.custom_name }}
            </template>
            <template #filter="{filterModel}">
              <InputText
                type="text"
                v-model="filterModel.value"
                class="p-column-filter"
                placeholder="Search by contract"
              />
            </template>
          </Column>

          <Column
            header="Portfolio"
            sortable
            filterField="fk_idportfolio"
            sortField="fk_idportfolio"
            :showFilterMatchModes="false"
            :filterMenuStyle="{ width: '14rem' }"
            :styles="{ 'min-width': '8rem' }"
          >
            <template #body="{data}">
              {{ data.fk_idportfolio }}
            </template>
            <template #filter="{filterModel}">
              <div class="mb-3 font-bold">Portfolio Picker</div>
              <MultiSelect
                v-model="filterModel.value"
                :options="portfoliosDDown"
                placeholder="Select Portfolio"
                class="p-column-filter"
                scrollHeight="400px"
              >
                <template #option="slotProps">
                  <div class="p-multiselect-representative-option">
                    <span class="image-text">{{ slotProps.option }}</span>
                  </div>
                </template>
              </MultiSelect>
            </template>
          </Column>

          <Column
            header="Product"
            sortable
            filterField="fk_id_end_product"
            sortField="fk_id_end_product"
            :showFilterMatchModes="false"
            :filterMenuStyle="{ width: '8rem' }"
            :styles="{ 'min-width': '8rem' }"
          >
            <template #body="{data}">
              {{ data.fk_id_end_product }}
            </template>
            <template #filter="{filterModel}">
              <div class="mb-3 font-bold">Product Picker</div>
              <MultiSelect
                v-model="filterModel.value"
                :options="productDDown"
                placeholder="Select Product"
                class="p-column-filter"
                scrollHeight="400px"
              >
                <template #option="slotProps">
                  <div class="p-multiselect-representative-option">
                    <span class="image-text">{{ slotProps.option }}</span>
                  </div>
                </template>
              </MultiSelect>
            </template>
          </Column>

          <Column
            header="Commodity"
            sortable
            filterField="fk_idcommodity"
            sortField="fk_idcommodity"
            :showFilterMatchModes="false"
            :filterMenuStyle="{ width: '14rem' }"
            :styles="{ 'min-width': '9rem' }"
          >
            <template #body="{data}">
              {{ data.fk_idcommodity }}
            </template>
            <template #filter="{filterModel}">
              <div class="mb-3 font-bold">Commodity Picker</div>
              <MultiSelect
                v-model="filterModel.value"
                :options="commoditiesDDown"
                placeholder="Select Commodities"
                class="p-column-filter"
                scrollHeight="400px"
              >
                <template #option="slotProps">
                  <div class="p-multiselect-representative-option">
                    <span class="image-text">{{ slotProps.option }}</span>
                  </div>
                </template>
              </MultiSelect>
            </template>
          </Column>

          <Column
            header="Exposure Type"
            sortable
            filterField="fk_idcommodityexposureoption"
            sortField="fk_idcommodityexposureoption"
            :showFilterMatchModes="false"
            :filterMenuStyle="{ width: '14rem' }"
            :styles="{ 'min-width': '9rem' }"
          >
            <template #body="{data}">
              {{ data.fk_idcommodityexposureoption }}
            </template>
            <template #filter="{filterModel}">
              <div class="mb-3 font-bold">Exposure Picker</div>
              <MultiSelect
                v-model="filterModel.value"
                :options="expoTypeDDown"
                placeholder="Select Type"
                class="p-column-filter"
                scrollHeight="400px"
              >
                <template #option="slotProps">
                  <div class="p-multiselect-representative-option">
                    <span class="image-text">{{ slotProps.option }}</span>
                  </div>
                </template>
              </MultiSelect>
            </template>
          </Column>

          <Column
            header="Pricing method"
            sortable
            filterField="fk_idpricingmethod"
            sortField="fk_idpricingmethod"
            :showFilterMatchModes="false"
            :filterMenuStyle="{ width: '14rem' }"
            :styles="{ 'min-width': '10rem' }"
          >
            <template #body="{data}">
              {{ data.fk_idpricingmethod }}
            </template>
            <template #filter="{filterModel}">
              <div class="mb-3 font-bold">Pricing Picker</div>
              <MultiSelect
                v-model="filterModel.value"
                :options="pricingMethodDDown"
                placeholder="Select Pricing Method"
                class="p-column-filter"
                scrollHeight="400px"
              >
                <template #option="slotProps">
                  <div class="p-multiselect-representative-option">
                    <span class="image-text">{{ slotProps.option }}</span>
                  </div>
                </template>
              </MultiSelect>
            </template>
          </Column>

          <Column
            field="date"
            header="Date"
            sortable
            dataType="date"
            :styles="{ 'min-width': '5rem' }"
          >
            <template #body="{data}">
              {{ data.date | dateFormat }}
            </template>
            <template #filter="{filterModel}">
              <Calendar
                v-model="filterModel.value"
                dateFormat="mm/dd/yy"
                placeholder="mm/dd/yyyy"
              />
            </template>
          </Column>

          <Column
            field="quantity"
            header="Quantity"
            sortable
            dataType="numeric"
            :styles="{ 'min-width': '8rem' }"
          >
            <template #body="{data}">
              {{ data.quantity | numberFormat }}
            </template>
            <template #filter="{filterModel}">
              <InputNumber v-model="filterModel.value" />
            </template>
          </Column>

          <Column
            field="contract_month_year"
            header="Futures Date"
            sortable
            dataType="date"
            :styles="{ 'min-width': '5rem' }"
          >
            <template #body="{data}">
              {{ data.contract_month_year | futuresDateFormat }}
            </template>
            <template #filter="{filterModel}">
              <Calendar
                v-model="filterModel.value"
                dateFormat="mm/dd/yy"
                placeholder="mm/dd/yyyy"
              />
            </template>
          </Column>

          <Column
            field="continuation_month"
            header="Continuation month"
            sortable
            dataType="numeric"
            :styles="{ 'min-width': '10rem' }"
          >
            <template #body="{data}">
              {{ data.continuation_month | numberFormat }}
            </template>
            <template #filter="{filterModel}">
              <InputNumber v-model="filterModel.value" />
            </template>
          </Column>

          <Column
            v-if="showAllFields"
            field="fixation_date"
            header="Last Futures Fixation Date"
            sortable
            dataType="date"
            :styles="{ 'min-width': '5rem' }"
          >
            <template #body="{data}">
              {{ data.fixation_date | dateFormat }}
            </template>
            <template #filter="{filterModel}">
              <Calendar
                v-model="filterModel.value"
                dateFormat="mm/dd/yy"
                placeholder="mm/dd/yyyy"
              />
            </template>
          </Column>

          <Column
            v-if="showAllFields"
            field="purchase_date"
            header="Basis/Ratio Fixation Date"
            sortable
            dataType="date"
            :styles="{ 'min-width': '6rem' }"
          >
            <template #body="{data}">
              {{ data.purchase_date | dateFormat }}
            </template>
            <template #filter="{filterModel}">
              <Calendar
                v-model="filterModel.value"
                dateFormat="mm/dd/yy"
                placeholder="mm/dd/yyyy"
              />
            </template>
          </Column>

          <Column
            field="base"
            header="Basis"
            sortable
            dataType="numeric"
            :styles="{ 'min-width': '8rem' }"
          >
            <template #body="{data}">
              {{ data.base | numberFormat }}
            </template>
            <template #filter="{filterModel}">
              <InputNumber v-model="filterModel.value" />
            </template>
          </Column>

          <Column
            field="ratio"
            header="Ratio"
            sortable
            dataType="numeric"
            :styles="{ 'min-width': '8rem' }"
          >
            <template #body="{data}">
              {{ data.ratio | numberFormat }}
            </template>
            <template #filter="{filterModel}">
              <InputNumber v-model="filterModel.value" />
            </template>
          </Column>

          <Column
            field="budget_futures"
            header="Futures Price"
            sortable
            dataType="numeric"
            :styles="{ 'min-width': '8rem' }"
          >
            <template #body="{data}">
              {{ data.budget_futures | numberFormat }}
            </template>
            <template #filter="{filterModel}">
              <InputNumber v-model="filterModel.value" />
            </template>
          </Column>

          <Column
            field="budget_price"
            header="Price"
            sortable
            dataType="numeric"
            :styles="{ 'min-width': '8rem' }"
          >
            <template #body="{data}">
              {{ data.budget_price | numberFormat }}
            </template>
            <template #filter="{filterModel}">
              <InputNumber v-model="filterModel.value" />
            </template>
          </Column>

          <Column
            v-if="showAllFields"
            field="auto3"
            header="Freight"
            sortable
            dataType="numeric"
            :styles="{ 'min-width': '8rem' }"
          >
            <template #body="{data}">
              {{ data.auto3 | numberFormat }}
            </template>
            <template #filter="{filterModel}">
              <InputNumber v-model="filterModel.value" />
            </template>
          </Column>

          <Column
            v-if="showAllFields"
            field="insurance"
            header="Insurance"
            sortable
            dataType="numeric"
            :styles="{ 'min-width': '5rem' }"
          >
            <template #body="{data}">
              {{ data.insurance | numberFormat }}
            </template>
            <template #filter="{filterModel}">
              <InputNumber v-model="filterModel.value" />
            </template>
          </Column>

          <Column
            v-if="showAllFields"
            field="tariffs"
            header="Tariffs"
            sortable
            dataType="numeric"
            :styles="{ 'min-width': '5rem' }"
          >
            <template #body="{data}">
              {{ data.tariffs | numberFormat }}
            </template>
            <template #filter="{filterModel}">
              <InputNumber v-model="filterModel.value" />
            </template>
          </Column>

          <Column
            field="request_number"
            header="Request Number"
            sortable
            :styles="{ 'min-width': '8rem' }"
          >
            <template #body="{data}">
              {{ data.request_number }}
            </template>
            <template #filter="{filterModel}">
              <InputText
                type="text"
                v-model="filterModel.value"
                class="p-column-filter"
                placeholder="Search by request number"
              />
            </template>
          </Column>

          <Column
            field="purchase_order"
            header="Purchase Order"
            sortable
            :styles="{ 'min-width': '8rem' }"
          >
            <template #body="{data}">
              {{ data.purchase_order }}
            </template>
            <template #filter="{filterModel}">
              <InputText
                type="text"
                v-model="filterModel.value"
                class="p-column-filter"
                placeholder="Search by purchose order"
              />
            </template>
          </Column>

          <Column
            v-if="showAllFields"
            field="loading_date"
            header="Loading Date"
            sortable
            dataType="date"
            :styles="{ 'min-width': '5rem' }"
          >
            <template #body="{data}">
              {{ data.loading_date | dateFormat }}
            </template>
            <template #filter="{filterModel}">
              <Calendar
                v-model="filterModel.value"
                dateFormat="mm/dd/yy"
                placeholder="mm/dd/yyyy"
              />
            </template>
          </Column>

          <Column
            v-if="showAllFields"
            field="shipping_date"
            header="Shipping Date"
            sortable
            dataType="date"
            :styles="{ 'min-width': '5rem' }"
          >
            <template #body="{data}">
              {{ data.shipping_date | dateFormat }}
            </template>
            <template #filter="{filterModel}">
              <Calendar
                v-model="filterModel.value"
                dateFormat="mm/dd/yy"
                placeholder="mm/dd/yyyy"
              />
            </template>
          </Column>

          <Column
            v-if="showAllFields"
            field="eta"
            header="Delivery Date"
            sortable
            dataType="date"
            :styles="{ 'min-width': '5rem' }"
          >
            <template #body="{data}">
              {{ data.eta | dateFormat }}
            </template>
            <template #filter="{filterModel}">
              <Calendar
                v-model="filterModel.value"
                dateFormat="mm/dd/yy"
                placeholder="mm/dd/yyyy"
              />
            </template>
          </Column>

          <Column
            v-if="showAllFields"
            field="fk_id_business"
            header="Business"
            sortable
            :styles="{ 'min-width': '5rem' }"
          >
            <template #body="{data}">
              {{ data.fk_id_business }}
            </template>
            <template #filter="{filterModel}">
              <InputText
                type="text"
                v-model="filterModel.value"
                class="p-column-filter"
                placeholder="Search by business"
              />
            </template>
          </Column>

          <Column
            v-if="showAllFields"
            header="Country of Origin"
            sortable
            filterField="country_origin_name"
            sortField="country_origin_name"
            :showFilterMatchModes="false"
            :filterMenuStyle="{ width: '8rem' }"
            :styles="{ 'min-width': '8rem' }"
          >
            <template #body="{data}">
              {{ data.country_origin_name }}
            </template>
            <template #filter="{filterModel}">
              <div class="mb-3 font-bold">Country Picker</div>
              <MultiSelect
                v-model="filterModel.value"
                :options="countryOriginDDown"
                placeholder="Select Country"
                class="p-column-filter"
                scrollHeight="400px"
              >
                <template #option="slotProps">
                  <div class="p-multiselect-representative-option">
                    <span class="image-text">{{ slotProps.option }}</span>
                  </div>
                </template>
              </MultiSelect>
            </template>
          </Column>

          <Column
            v-if="showAllFields"
            header="Destination Country"
            sortable
            filterField="country_name"
            sortField="country_name"
            :showFilterMatchModes="false"
            :filterMenuStyle="{ width: '10rem' }"
            :styles="{ 'min-width': '10rem' }"
          >
            <template #body="{data}">
              {{ data.country_name }}
            </template>
            <template #filter="{filterModel}">
              <div class="mb-3 font-bold">Country Picker</div>
              <MultiSelect
                v-model="filterModel.value"
                :options="countryDDown"
                placeholder="Select Country"
                class="p-column-filter"
                scrollHeight="400px"
              >
                <template #option="slotProps">
                  <div class="p-multiselect-representative-option">
                    <span class="image-text">{{ slotProps.option }}</span>
                  </div>
                </template>
              </MultiSelect>
            </template>
          </Column>

          <Column
            v-if="showAllFields"
            header="Supplier"
            sortable
            filterField="fk_id_provider"
            sortField="fk_id_provider"
            :showFilterMatchModes="false"
            :filterMenuStyle="{ width: '8rem' }"
            :styles="{ 'min-width': '8rem' }"
          >
            <template #body="{data}">
              {{ data.fk_id_provider }}
            </template>
            <template #filter="{filterModel}">
              <div class="mb-3 font-bold">Supplier Picker</div>
              <MultiSelect
                v-model="filterModel.value"
                :options="supplierDDown"
                placeholder="Select supplier"
                class="p-column-filter"
                scrollHeight="400px"
              >
                <template #option="slotProps">
                  <div class="p-multiselect-representative-option">
                    <span class="image-text">{{ slotProps.option }}</span>
                  </div>
                </template>
              </MultiSelect>
            </template>
          </Column>

          <Column
            v-if="showAllFields"
            field="client"
            header="Client"
            sortable
            :styles="{ 'min-width': '8rem' }"
          >
            <template #body="{data}">
              {{ data.client }}
            </template>
            <template #filter="{filterModel}">
              <InputText
                type="text"
                v-model="filterModel.value"
                class="p-column-filter"
                placeholder="Search by client"
              />
            </template>
          </Column>

          <Column
            v-if="showAllFields"
            header="Plant"
            sortable
            filterField="fk_id_plant"
            sortField="fk_id_plant"
            :showFilterMatchModes="false"
            :filterMenuStyle="{ width: '8rem' }"
            :styles="{ 'min-width': '8rem' }"
          >
            <template #body="{data}">
              {{ data.fk_id_plant }}
            </template>
            <template #filter="{filterModel}">
              <div class="mb-3 font-bold">Plant Picker</div>
              <MultiSelect
                v-model="filterModel.value"
                :options="plantDDown"
                placeholder="Select Plant"
                class="p-column-filter"
                scrollHeight="400px"
              >
                <template #option="slotProps">
                  <div class="p-multiselect-representative-option">
                    <span class="image-text">{{ slotProps.option }}</span>
                  </div>
                </template>
              </MultiSelect>
            </template>
          </Column>

          <Column
            v-if="showAllFields"
            header="Port"
            sortable
            filterField="port"
            sortField="port"
            :showFilterMatchModes="false"
            :filterMenuStyle="{ width: '8rem' }"
            :styles="{ 'min-width': '8rem' }"
          >
            <template #body="{data}">
              {{ data.port }}
            </template>
            <template #filter="{filterModel}">
              <div class="mb-3 font-bold">Port Picker</div>
              <MultiSelect
                v-model="filterModel.value"
                :options="portDDown"
                placeholder="Select port"
                class="p-column-filter"
                scrollHeight="400px"
              >
                <template #option="slotProps">
                  <div class="p-multiselect-representative-option">
                    <span class="image-text">{{ slotProps.option }}</span>
                  </div>
                </template>
              </MultiSelect>
            </template>
          </Column>

          <Column
            v-if="showAllFields"
            field="settlement_price"
            header="Last Fixation Price"
            sortable
            dataType="numeric"
            :styles="{ 'min-width': '8rem' }"
          >
            <template #body="{data}">
              {{ data.settlement_price | numberFormat }}
            </template>
            <template #filter="{filterModel}">
              <InputNumber v-model="filterModel.value" />
            </template>
          </Column>

          <Column
            v-if="showAllFields"
            field="comments"
            header="Comments"
            sortable
            :styles="{ 'min-width': '10rem' }"
          >
            <template #body="{data}">
              {{ data.comments }}
            </template>
            <template #filter="{filterModel}">
              <InputText
                type="text"
                v-model="filterModel.value"
                class="p-column-filter"
                placeholder="Search by comments"
              />
            </template>
          </Column>
        </DataTable>
      </div>
    </div>
    <!-- Loading Modal -->
    <Messages :modal_message="modal_processing_message" />
    <Messages :modal_message="modal_process_finished_message" />
  </div>
</template>

<script>
import { gatewayService } from "@/_services/gateway.service";
import { Company } from "@/_core/data/Company";
import { FilterMatchMode, FilterOperator } from "primevue/api/";
import { SheetsTransaction } from "@/_core/export/SheetsTransaction";
import { timeFormat, format } from "d3";
import Calendar from "primevue/calendar";
import Column from "primevue/column";
import DataTable from "primevue/datatable";
import InputNumber from "primevue/inputnumber";
import InputText from "primevue/inputtext";
import Messages from "../modals/Messages.vue";
import MultiSelect from "primevue/multiselect";
import ToggleButton from "@/components/ToggleButton.vue";
import { createDataModelTable } from "@/_core/data/SaveToDB";

export default {
  name: "DataTableExpoCommodities",
  components: {
    Calendar,
    Column,
    DataTable,
    InputNumber,
    InputText,
    Messages,
    MultiSelect,
    ToggleButton,
  },
  props: {
    dataSaved: { required: true },
    dataVar: { required: true },
    headersToExport: { required: true },
    list_file: { required: true },
    processData: { required: true },
    refreshLegend: { required: true },
    saveLegend: { required: true },
    selectedCompany: { required: true },
    selectedList: { required: true },
    selectedNAsset: { required: true },
    selectedPortfolios: { required: true },
    showLoading: { required: true },
  },
  data() {
    return {
      companies: [],
      dataToExport: [],
      selection: "com_expo",
      filters: {
        fk_idportfolio: { value: null, matchMode: FilterMatchMode.IN },
        fk_idcommodity: { value: null, matchMode: FilterMatchMode.IN },
        fk_idcommodityexposureoption: {
          value: null,
          matchMode: FilterMatchMode.IN,
        },
        fk_idpricingmethod: { value: null, matchMode: FilterMatchMode.IN },
        date: {
          operator: FilterOperator.AND,
          constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }],
        },
        quantity: {
          operator: FilterOperator.AND,
          constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
        },
        contract_month_year: {
          operator: FilterOperator.AND,
          constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }],
        },
        continuation_month: {
          operator: FilterOperator.AND,
          constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
        },
        shipping_date: {
          operator: FilterOperator.AND,
          constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }],
        },
        loading_date: {
          operator: FilterOperator.AND,
          constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }],
        },
        eta: {
          operator: FilterOperator.AND,
          constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }],
        },
        fk_id_end_product: { value: null, matchMode: FilterMatchMode.IN },
        custom_name: {
          operator: FilterOperator.AND,
          constraints: [
            { value: null, matchMode: FilterMatchMode.STARTS_WITH },
          ],
        },
        custom_id: {
          operator: FilterOperator.AND,
          constraints: [
            { value: null, matchMode: FilterMatchMode.STARTS_WITH },
          ],
        },
        fk_id_provider: { value: null, matchMode: FilterMatchMode.IN },
        client: {
          operator: FilterOperator.AND,
          constraints: [
            { value: null, matchMode: FilterMatchMode.STARTS_WITH },
          ],
        },
        fk_id_plant: { value: null, matchMode: FilterMatchMode.IN },
        port: { value: null, matchMode: FilterMatchMode.IN },
        base: {
          operator: FilterOperator.AND,
          constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
        },
        ratio: {
          operator: FilterOperator.AND,
          constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
        },
        budget_futures: {
          operator: FilterOperator.AND,
          constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
        },
        budget_price: {
          operator: FilterOperator.AND,
          constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
        },
        auto3: {
          operator: FilterOperator.AND,
          constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
        },
        insurance: {
          operator: FilterOperator.AND,
          constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
        },
        tariffs: {
          operator: FilterOperator.AND,
          constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
        },
        comments: {
          operator: FilterOperator.AND,
          constraints: [
            { value: null, matchMode: FilterMatchMode.STARTS_WITH },
          ],
        },
        request_number: {
          operator: FilterOperator.AND,
          constraints: [
            { value: null, matchMode: FilterMatchMode.STARTS_WITH },
          ],
        },
        purchase_order: {
          operator: FilterOperator.AND,
          constraints: [
            { value: null, matchMode: FilterMatchMode.STARTS_WITH },
          ],
        },
        fk_id_business: {
          operator: FilterOperator.AND,
          constraints: [
            { value: null, matchMode: FilterMatchMode.STARTS_WITH },
          ],
        },
        country_origin_name: { value: null, matchMode: FilterMatchMode.IN },
        country_name: { value: null, matchMode: FilterMatchMode.IN },
        settlement_price: {
          operator: FilterOperator.AND,
          constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
        },
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      },
      modal_process_finished_message: {
        showModalLoading: false,
        messageModal: "",
        optionsModal: false,
      },
      modal_processing_message: {
        showModalLoading: false,
        messageModal: "",
        optionsModal: false,
      },
      selectedExposures: null,
      sheetTransaction: null,
      showFilters: true,
      showAllFields: false,
      showMore: "+ Fields",
      user: [],
    };
  },
  computed: {
    portfoliosDDown() {
      return this.dataVar
        .map((d) => d.fk_idportfolio)
        .sort()
        .filter(this.processData.onlyUnique)
        .filter((d) => d != null && d !== "");
    },
    commoditiesDDown() {
      return this.dataVar
        .map((d) => d.fk_idcommodity)
        .sort()
        .filter(this.processData.onlyUnique)
        .filter((d) => d != null && d !== "");
    },
    countryDDown() {
      return this.dataVar
        .map((d) => d.country_name)
        .sort()
        .filter(this.processData.onlyUnique)
        .filter((d) => d);
    },
    countryOriginDDown() {
      return this.dataVar
        .map((d) => d.country_origin_name)
        .sort()
        .filter(this.processData.onlyUnique)
        .filter((d) => d);
    },
    expoTypeDDown() {
      return this.dataVar
        .map((d) => d.fk_idcommodityexposureoption)
        .sort()
        .filter(this.processData.onlyUnique)
        .filter((d) => d != null && d !== "");
    },
    pricingMethodDDown() {
      return this.dataVar
        .map((d) => d.fk_idpricingmethod)
        .sort()
        .filter(this.processData.onlyUnique)
        .filter((d) => d != null && d !== "");
    },
    productDDown() {
      return this.dataVar
        .map((d) => d.fk_id_end_product)
        .sort()
        .filter(this.processData.onlyUnique)
        .filter((d) => d != null && d !== "");
    },
    plantDDown() {
      return this.dataVar
        .map((d) => d.fk_id_plant)
        .sort()
        .filter(this.processData.onlyUnique)
        .filter((d) => d != null && d !== "");
    },
    supplierDDown() {
      return this.dataVar
        .map((d) => d.fk_id_provider)
        .sort()
        .filter(this.processData.onlyUnique)
        .filter((d) => d);
    },
    portDDown() {
      return this.dataVar
        .map((d) => d.port)
        .sort()
        .filter(this.processData.onlyUnique)
        .filter((d) => d);
    },
  },
  created() {
    try {
      this.sheetTransaction = new SheetsTransaction(
        this.dataToExport,
        this.headersToExport,
      );
    } catch (error) {
      console.log(`Error Process Data ${error}`);
    }
    try {
      this.user = this.$store.state.user.all.items;
    } catch (error) {
      console.log(`Error user ${error}`);
    }
    try {
      this.companies = this.$store.state.companies.all.items;
      this.companyLen = this.companies.length;
    } catch (error) {
      console.log(`Error companies ${error}`);
    }
    try {
      this.processed_company = new Company(this);
    } catch (error) {
      console.log(`Error companies loader ${error}`);
    }
  },
  methods: {
    // ====================== Emit variables ======================
    onClientCreate() {
      this.$emit("eventOnClientCreate");
    },
    onEditItem(item) {
      this.$emit("eventOnEditItem", item);
    },
    onDeleteItem(item) {
      this.$emit("eventOnDeleteItem", item);
    },
    onCopyItem(item) {
      this.$emit("eventOnCopyItem", item);
    },
    onClientSaveToDB() {
      this.$emit("eventOnClientSaveToDB");
    },
    onClientDiscard() {
      this.$emit("eventOnClientDiscard");
    },
    onAfterDelete() {
      this.$emit("eventOnAfterDelete");
    },
    onAfterDeleteCompany() {
      this.$emit("eventOnAfterDeleteCompany");
    },

    // ====================== DB related ======================
    deleteFromDB() {
      var r = confirm(
        "Are you sure you want to delete this table (exposure/hedges)?",
      );
      if (r === true) {
        let deleteTable = null;
        let getPortfolioNumber = [];
        let vis = this;
        this.companies = this.$store.state.companies.all.items;
        vis.selectedPortfolios.forEach(function(selectedPortfolio) {
          getPortfolioNumber.push(
            vis.companies[vis.selectedCompany].portfolios[selectedPortfolio.id]
              .pk_idportfolio,
          );
        });
        if (this.selectedList === 0 && this.selectedNAsset === 0) {
          deleteTable = gatewayService.currencies.deleteExposure;
        }
        if (this.selectedList === 0 && this.selectedNAsset === 1) {
          deleteTable = gatewayService.commodities.deleteExposure;
        }
        if (this.selectedList === 1 && this.selectedNAsset === 0) {
          deleteTable = gatewayService.currencies.deleteHedge;
        }
        if (this.selectedList === 1 && this.selectedNAsset === 1) {
          deleteTable = gatewayService.commodities.deleteHedge;
        }
        let payload = {
          format: "json",
          selected_company: this.companies[this.selectedCompany].pk_idcompany,
          user_id: this.user.pk_idusers,
          selection: this.selectedList,
          selected_porfolios: { id_portfolios: getPortfolioNumber },
        };
        this.modal_processing_message.showModalLoading = !this
          .modal_processing_message.showModalLoading;
        this.modal_processing_message.messageModal = "Deleting....";
        var delay_state = this;
        deleteTable(payload)
          .then((data) => {
            this.processed_company.onLoadData();
            setTimeout(function() {
              delay_state.modal_processing_message.showModalLoading = !delay_state
                .modal_processing_message.showModalLoading;
              delay_state.modal_process_finished_message.showModalLoading = !delay_state
                .modal_process_finished_message.showModalLoading;
              delay_state.modal_process_finished_message.optionsModal = true;
              delay_state.modal_process_finished_message.messageModal =
                data["successful"];
              delay_state.onAfterDeleteCompany();
              delay_state.onAfterDelete();
            }, 10000);
          })
          .catch((error) => {
            this.modal_processing_message.showModalLoading = !this
              .modal_processing_message.showModalLoading;
            this.modal_process_finished_message.showModalLoading = !this
              .modal_process_finished_message.showModalLoading;
            this.modal_process_finished_message.optionsModal = true;
            this.modal_process_finished_message.messageModal =
              "An error has occurred" + error;
          });
      }
    },
    download() {
      this.$refs.dt.processedData.forEach((d) => {
        d.fk_id_country_of_origin = d.country_origin_name;
        d.fk_idcountry = d.country_name;
      });
      createDataModelTable(this);
    },
  },
  filters: {
    dateFormat: function(val) {
      if (val && typeof val === "string") {
        val += "T00:00:00.000";
        val = new Date(val);
      }
      return !val || +val < +new Date(1980, 1, 1)
        ? "-"
        : timeFormat("%d %b %y")(val);
    },
    futuresDateFormat: function(val) {
      return !val || +val < +new Date(1980, 1, 1)
        ? "-"
        : timeFormat("%b%y")(val).toUpperCase();
    },
    numberFormat: function(val) {
      return !val ? "-" : format(",")(val);
    },
  },
};
</script>
